<template>
  <VueMarkdown
    :source="source"
    :options="options"
    class="re-markdown"
    :class="[
      {
        're-markdown--text': text,
      },
      getMarkdownHeadingClass(headingSize),
    ]"
  />
</template>

<script setup lang="ts">
import type { MarkdownHeadingSize } from '@/elements/markdown'

import VueMarkdown from 'vue-markdown-render'
import { getMarkdownHeadingClass } from '@/elements/markdown'

const {
  source = '',
  options = {},
  text = false,
  headingSize = 'default',
} = defineProps<{
  source?: string
  options?: Record<string, unknown>
  text?: boolean
  headingSize?: MarkdownHeadingSize
}>()
</script>
